import InvalidTMSIDModal from './InvalidTMSIDModal';

export default InvalidTMSIDModal;
